module.exports = __webpack_public_path__ + "img/fondo_control_icons-orig.8ab9f4ab.png";